export default {
  name: 'SiteFooter'
};